import { forwardRef } from "react";
import { cn } from "@/lib/cn";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  invalid?: boolean;
};

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid, className, rows = 3, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      aria-invalid={invalid || undefined}
      className={cn(
        "w-full rounded-md bg-bg-base border px-2.5 py-2 text-[14px] leading-relaxed text-fg placeholder:text-fg-muted",
        "focus-ring focus-visible:border-brand-500/50",
        "disabled:cursor-not-allowed disabled:opacity-60",
        invalid ? "border-status-critical/50" : "border-line-subtle",
        className,
      )}
      {...rest}
    />
  );
});
